import * as React from "react";
import { Empty, Radio, Spin } from "antd";
import { ModalPlm } from "src/components/ModalPlm";
import { onError } from "src/common/onError";
import styles from "./Mc2EntityBaseSizeModal.module.less";

interface PropsMc2EntityBaseSizeModal {
  open: boolean;
  close: () => void;
  options: string[];
  currentBaseSize: string;
  onChange: (baseSize: string) => Promise<void>;
  loading: boolean;
}

export const Mc2EntityBaseSizeModal: React.FC<PropsMc2EntityBaseSizeModal> = ({
  open,
  close,
  options,
  currentBaseSize,
  onChange,
  loading,
}) => {
  const [value, setValue] = React.useState<string>(currentBaseSize);

  React.useEffect(() => {
    if (open) {
      setValue(currentBaseSize);
    }
  }, [open, currentBaseSize]);

  const disabled = !value || value === currentBaseSize;

  return (
    <ModalPlm
      width={700}
      title="Изменение базового размера"
      open={open}
      onCancel={close}
      okText="Изменить"
      okButtonProps={{ disabled, loading }}
      onOk={() => {
        onChange(value).catch(onError);
      }}
    >
      <Spin spinning={loading}>
        <div className={styles.content}>
          <div className={styles.label}>Выбрать как базовый размер:</div>
          {options.length === 0 ? (
            <Empty
              image={Empty.PRESENTED_IMAGE_SIMPLE}
              description="Нет доступных размеров"
            />
          ) : (
            <Radio.Group
              className={styles.list}
              value={value}
              onChange={(e) => setValue(e.target.value)}
            >
              {options.map((size) => (
                <Radio key={size} value={size}>
                  {size}
                </Radio>
              ))}
            </Radio.Group>
          )}
        </div>
      </Spin>
    </ModalPlm>
  );
};
